import {
  AccessDeniedError,
  ServerGatewayTimeoutError,
  ServerInternalError,
  ServerNotFoundError,
  ServerUnauthorizedError,
  ServerUnavailableError,
  ServerValidationError,
} from '@modules/core/errors/index';

export const SENTRY_IGNORED_ERROR_NAMES_LIST = [
  ServerValidationError,
  ServerUnauthorizedError,
  ServerUnavailableError,
  ServerInternalError,
  AccessDeniedError,
  ServerNotFoundError,
  ServerGatewayTimeoutError,
].map((a) => a.name);
export const REQUEST_NO_RETRY_ERROR_NAMES_LIST = [
  ServerValidationError,
  ServerUnauthorizedError,
  AccessDeniedError,
  ServerNotFoundError,
].map((a) => a.name);

export function isInErrorExclusionList(error: unknown, exclusionList: string[]): boolean {
  return error instanceof Error && exclusionList.includes(error.constructor.name);
}
